import { iAuth, iUser } from "@/services";
import Util from "@/common/util";
import i18n from "@/locales";
import CONSTANTS from "@/common/constants";

const state = {
  token: Util.getToken(CONSTANTS.TOKEN.AUTH),
  profile: "",
  userData: {
    id: 0,
    role: "",
    roleNm: "",
    name: "",
    email: "",
    language: "",
    menuAuth: [],
    createdDate: "",
    sensitive: {},
    setting: {},
  },
  pageAuth: {},
};

const mutations = {
  setInitialize: (state) => {
    state.token = null;
    state.userData = {};
    Util.removeToken(CONSTANTS.TOKEN.AUTH);
    Util.removeToken(CONSTANTS.TOKEN.USER_DATA);
  },
  setAuthToken: (state, data) => {
    state.token = data;
    Util.setToken(CONSTANTS.TOKEN.AUTH, data);
  },
  setUserDataFromToken: (state) => {
    const data = Util.getToken(CONSTANTS.TOKEN.USER_DATA);
    state.userData.id = data.id;
    state.userData.role = data.role;
    state.userData.roleNm = data.roleNm;
    state.userData.name = data.name;
    state.userData.email = data.email;
    state.userData.language = data.language;
    state.userData.menuAuth = data.menuAuth;
  },
  setProfile: (state, data) => {
    state.profile = data;
  },
  setUserData: (state, data) => {
    const userData = {
      id: data.id,
      language: data.language,
      role: data.role,
      roleNm: data.roleNm,
      menuAuth: data.menuAuth,
      name: data.name,
      email: data.email,
    };

    state.userData = userData;
    Util.setToken(CONSTANTS.TOKEN.USER_DATA, userData);
    i18n.locale = data.language;
  },
  setPageAuth: (state, data) => {
    state.pageAuth = data;
  },
  setLocale: (state, data) => {
    state.userData.language = data;
    Util.setToken(CONSTANTS.TOKEN.USER_DATA, state.userData);
    i18n.locale = data;
  },
  setUserName: (state, newName) => {
    state.userData.name = newName;
    Util.setToken(CONSTANTS.TOKEN.USER_DATA, state.userData);
  },
  setMyInfo: (state, data) => {
    state.userData.setting = data.setting;
    state.userData.sensitive = data.sensitive;
    state.userData.createdDate = data.createdDate;
  },
};

const actions = {
  async logIn({ commit, dispatch }, data) {
    commit("setInitialize");
    try {
      const res = await iAuth.logIn(data);

      const authorization = res.headers.authorization || "";
      commit("setAuthToken", authorization);
      dispatch("myInfo");

      if (!res.data.code) {
        const menuResult = await iAuth.getMenus();
        res.data.payload.menuAuth = menuResult.data.menuRoles;

        commit("setUserData", res.data.payload);
      }

      return res.data;
    } catch (error) {
      console.log("[Error] Failed to login : ", error);
      // error.data.code -> 알림
    }
  },
  async logOut({ state, dispatch }) {
    await iAuth.logOut({ userId: state.userData.id });
    dispatch("clearAuth");
  },
  async clearAuth({ commit }) {
    commit("setUserData", {});
    Util.removeToken(CONSTANTS.TOKEN.AUTH);
    Util.removeToken(CONSTANTS.TOKEN.USER_DATA);
  },
  async setPageAuth({ commit }, data) {
    const payload = { menuCode: data };
    const res = await iAuth.hasRole(payload);
    commit("setPageAuth", res.data);
    return res.data.code;
  },
  async updateUserName({ commit }, newName) {
    commit("setUserName", newName);
  },
  async myInfo({ commit }) {
    const result = await iUser.getCurrentUser();
    const user = result.data.payload;

    if (!user) return;

    const profile = await iUser.getProfile();
    commit("setProfile", profile.data.payload);
    commit("setMyInfo", user);
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
